module.exports = __webpack_public_path__ + "img/banner.653c2c6e.jpg";